import zhjsondata from "./datalangzh.json";
import jpjsondata from "./datalangjp.json";
import kojsondata from "./datalangko.json";
import idjsondata from "./datalangid.json";
import esjsondata from "./datalanges.json";
import thjsondata from "./datalangth.json";
import ptjsondata from "./datalangpt.json";
import { saveChannelChange } from "../api/user";
// 根据环境不同引入不同api地址
import { channel } from "../config/index";
import { getClientAuthToken } from "./authStorage";
export function getRandomLetters(length) {
  // 定义可用于生成随机字符的字母表
  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

  let randomLetters = "";
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * letters.length);
    randomLetters += letters[randomIndex];
  }
  return randomLetters;
}
export function getLanguageFun(lang) {
  let language = "英语";
  try {
    lang = (lang && lang.toLowerCase()) || "";
    // 使用 includes 进行匹配
    if (lang.includes("zh")) {
      language = "中文";
    } else if (lang.includes("en")) {
      language = "英语";
    } else if (lang.includes("ja") || lang.includes("jp")) {
      language = "日语";
    } else if (lang.includes("ko")) {
      language = "韩语";
    } else if (lang.includes("id")) {
      language = "印尼语";
    } else if (lang.includes("es")) {
      language = "西班牙语";
    } else if (lang.includes("th")) {
      language = "泰语";
    } else if (lang.includes("pt")) {
      language = "葡萄牙语";
    } else {
      language = "其他语言";
    }
  } catch (error) {}
  return language;
}

// 获取受支持的语言key（zh-TW / en / ja / ko），优先本地缓存
export function getSupportedLanguageKey() {
  try {
    // 优先使用用户已选择并缓存的语言
    const localLanguage = localStorage.getItem("my_language");
    if (localLanguage) {
      return localLanguage;
    }
    const languageOptions = ["zh-TW", "en", "ja", "ko", "id", "es", "th", "pt"];
    const browserLanguage = (navigator.language || navigator.userLanguage || "").toLowerCase();
    console.log("browserLanguage= -----", browserLanguage);
    let mappedBrowserLanguage = "en";
    if (browserLanguage.includes("zh")) {
      mappedBrowserLanguage = "zh-TW";
    } else if (browserLanguage.includes("ja") || browserLanguage.includes("jp")) {
      mappedBrowserLanguage = "ja";
    } else if (browserLanguage.includes("ko")) {
      mappedBrowserLanguage = "ko";
    } else if (browserLanguage.includes("id")) {
      mappedBrowserLanguage = "id";
    } else if (browserLanguage.includes("es")) {
      mappedBrowserLanguage = "es";
    } else if (browserLanguage.includes("th")) {
      mappedBrowserLanguage = "th";
    } else if (browserLanguage.includes("pt")) {
      mappedBrowserLanguage = "pt";
    }
    // 只允许上述语言key，不命中则回退 en
    const finalLanguage = languageOptions.includes(mappedBrowserLanguage) ? mappedBrowserLanguage : "en";
    // 首次进入时写入缓存，后续直接走本地语言
    localStorage.setItem("my_language", finalLanguage);
    return finalLanguage;
  } catch (error) {
    return "en";
  }
}
// 语言设置
export function setLocalLangFun(lang = "en") {
  let obj = {
    networkError: "Network error. Please retry later!",
    retry: " Retry ",
    barhome: "Home",
    barmylist: "My List",
    barprofile: "Profile",
    play: "Play",
    hottrend: "Hot Trending",
    nomore: "No more data.",
    playmylist: "My List",
    playep: "EP",
    playepintotal: "# episodes in total",
    playunlockep: "Unlock Episodes",
    playallep: "All Episodes（#）",
    playnextep: "Next  # Episodes",
    playunlock: "Unlock",
    watchhistory: "Watch History",
    mylist: "My List",
    seeall: "See All",
    minelogin: "Login",
    mineuid: "Uid",
    mineunlockhistory: "Unlock History",
    mineabout: "About",
    about: "About",
    privacypo: " Privacy Policy ",
    serviceagr: "Service Agreement",
    ver: "Version: V",
    hanbook: "Han Book Pte. Ltd.",
    unlockhistory: "Unlock History",
    unlockep: "Unlocked《#######》EP. #-10 Beans",
    unlockbean: "Unlocked《#######》EP. #-#-100 Beans",
    playfail: "Failed to obtain the series, try switching to another series.",
    videofly: "Sorry, this drama is not available.",
    jumptip: "The previous episodes are also amazing! Don't miss it!",
    tip: "Tips",
    errtips: "Something is wrong. Please retry later!",
    loading: "Loading...",
    addsuc: "Added to my list.",
    addfail: "Failed to add to my list.",
    cancelsuc: "Remove from my list.",
    cancelfail: "Failed to remove from my list.",
    logfail: "Login failed",
    payfail: "Payment failed, please retry later.",
    prelogin: "Please log in.",
    buysuccess: "Purchased",
    buyfail: "Unlocking failed. Please retry later.",
    errornext: "Failed. Jumped to the next episode.",
    resultloading: "Querying the result...",
    iknowbtn: "OK",
    minelanguage: "Language",
    sharedesc: "Stream from any of your mobile devices wherever you are.",
    videoendtitle: "You've finished the last episode!",
    videoenddesc: "Next drama is on the way.",
    videoendbtn: "Play",
    minedone: "Done",
    homesearch: "Search",
    searchplaceholder: "Please enter a drama name.",
    searchhistory: "Search History",
    searchdel: "Sure to delete your recent search history?",
    searchdelbtn: "Delete",
    searchcancelbtn: "Cancel",
    searchresult: "Search Results",
    searchnotip: "Sorry, no results were found for ‘changerealvalue’.",
    minevipunbuytitle: "Membership",
    minevipunbuydesc: "VIP can watch all dramas for free!",
    minevipbuytitle: "Distinguished VIP!",
    minevipbuydesc: "Membership Available：",
    minevipunbuybtn: "Subscribe",
    vipboxtitle: "VIP Subscribe",
    vipfailtips: "Subscription failed. There may be unpaid charges on your app store.  Please check your payment account and try again.",
    vipfailbtn: "OK",
    membershipexpired: "Membership expired. Switching to playable episodes~",
    fullscreentohor: "Full Screen",
    videoErrTips: "Oops! Something is wrong. Please retry later!",
    pleasewatchad: "Ad has not been fully viewed.",
    proMiniTips: "Version doesn't support ads yet.",
    retaintitle: "Congratulations",
    retainvip: "#### VIP",
    retainfree: "All dramas free",
    retaintimer: "Limited Time ###",
    retainbtn: "Subscribe Now",
    vipweekly: "Weekly",
    vipmonthly: "Monthly",
    vipquarterly: "Quarterly",
    vipyearly: "Yearly"
  };
  try {
    lang = localStorage.getItem("my_language") || lang;
    let language = getLanguageFun(lang);
    console.log("用户系统语言:", "---", language);
    switch (language) {
      case "中文":
        obj = zhjsondata;
        break;
      case "日语":
        obj = jpjsondata;
        break;
      case "韩语":
        obj = kojsondata;
        break;
      case "印尼语":
        obj = idjsondata;
        break;
      case "西班牙语":
        obj = esjsondata;
        break;
      case "泰语":
        obj = thjsondata;
        break;
      case "葡萄牙语":
        obj = ptjsondata;
        break;
      default:
        break;
    }
  } catch (error) {
    console.log(error, "&&&&&&&&8989");
  }
  localStorage.setItem("curlangstorage", JSON.stringify(obj));
  return obj;
}

// 获取全部文案
export function getAllStrFun() {
  try {
    // 读取缓存
    let obj = localStorage.getItem("curlangstorage") || "{}";
    obj = JSON.parse(obj);
    if (obj && obj.barhome) {
      return obj;
    }
  } catch (error) {}
  return setLocalLangFun();
}

// 获取文案
export function getStrFun(key, defstr = "", changestr) {
  try {
    let obj = localStorage.getItem("curlangstorage") || "{}";
    obj = JSON.parse(obj);
    if (key && obj && obj[key]) {
      defstr = obj[key];
    }
    if (defstr && changestr) {
      defstr = defstr.replace("changerealvalue", changestr);
    }
  } catch (error) {}
  return defstr;
}

// 获取文案
export function replaceStrFun(strorigin = "", newstr = "", oldstr = "") {
  let str = strorigin;
  try {
    str = strorigin;
    // 如果 oldstr 不在 strorigin 中，原字符串不变
    if (!strorigin.includes(oldstr)) {
      return str;
    }
    // 使用正则表达式全局替换所有 occurrences
    const regex = new RegExp(oldstr, "g");
    str = strorigin.replace(regex, newstr);
  } catch (error) {}
  return str;
}
// 判断是否为安卓
export function isAndroidSys() {
  try {
    return /Android/i.test(navigator.userAgent);
  } catch (error) {
    return false
  }
}

export function checkChannelChanged(currentChannel){
  let bol = false;
  try {
    if (!getClientAuthToken()) {
      return false;
    }
    const localChannel = localStorage.getItem("channel");
    // console.log('checkChannelChanged... currentChannel = ', currentChannel, 'localStorage.getItem("channel") = ', localChannel)
    if (currentChannel && currentChannel !== localChannel) {
      localStorage.setItem("channel", currentChannel)
      const url = window.location.href; 
      localStorage.setItem("queryString", url);
      bol = true;
      saveChannelChange().catch(() => {});
    }
  } catch (error) {}
  // console.log('checkChannelChanged...util.js... bol = ', bol)
  return bol;
}

// 获取本地缓存的queryString的query
export function getLocalQueryStringSelf(vid, dramaNum, videoinfosession = null) {
  const channel0 = localStorage.getItem("channel") || channel;
  let obj = {
    channel: channel0,
  };
  try {
    if (vid) {
      if (dramaNum && dramaNum !== "undefined" && dramaNum !== "null") {
        obj = {
          vid: vid,
          dramaNum: dramaNum,
          channel: channel0,
        }
      } else {
        obj = {
          vid: vid,
          channel: channel0,
        }
      }
    }
    // 从分销页进入，且剧集数不为0，则设置剧集数为链接中带的剧集数
    if (videoinfosession && videoinfosession.mount_number && videoinfosession.mount_number !== "undefined" && videoinfosession.mount_number !== "null" && String(videoinfosession.mount_number) !== "0" && videoinfosession.state_from === "distributionpage") {
      obj.dramaNum = videoinfosession.mount_number;
    }
    if (videoinfosession && videoinfosession.charge_level) {
      obj.charge_level = videoinfosession.charge_level;
    }
  } catch (error) {}
  return obj;
}

// 获取本地缓存的queryString的query
export function getLocalQueryString(vid, dramaNum) {
  let queryRes = "";
  const channel0 = localStorage.getItem("channel") || channel;
  try {
    if (!vid) {
      return queryRes;
    }
    let url = localStorage.getItem("queryString");
    if (!url) {
      return `vid=${vid}&channel=${channel0}`;
    }
    // 提取主查询字符串部分
    const mainQueryString = url.split("?")[1];
    if (!mainQueryString) {
      return `vid=${vid}&channel=${channel0}`; // 如果没有查询字符串
    }
    const params = {};

    // 匹配查询参数，包括可能的嵌套 URL
    const regex = /([^&=?]+)=([^&]*)/g;
    let match;

    while ((match = regex.exec(mainQueryString)) !== null) {
      const key = decodeURIComponent(match[1]);
      const value = decodeURIComponent(match[2]);

      // 将键值对存入 params 对象中
      params[key] = value;
    }
    params.vid = vid;
    if (dramaNum) {
      params.dramaNum = dramaNum;
    }
    // 重新拼接成查询字符串
    queryRes = Object.entries(params).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join("&");
    return queryRes;
  } catch (error) {
    if (vid) {
      queryRes = `vid=${vid}&channel=${channel0}`;
    }
  }
  return queryRes;
}

// 事件回传埋点
export function reportEventFun(eventName, videoInfo, playingCurObj) {}
